import { STORAGE_CONFIG } from "@common/model/data";
import { getStorage } from "@common/utils";

export function toClientWithToken(url: string) {
  const token = getStorage(STORAGE_CONFIG.TOKEN);
  window.open(`${url}${url.includes("?") ? "&" : "?"}token=${token}`);
}
export function toClient(url: string) {
  const token = getStorage(STORAGE_CONFIG.TOKEN);
  window.open(`${url}${url.includes("?") ? "&" : "?"}`);
}
